import React from 'react';
import styles from './FontsList.module.scss';
import CompanyFonts from './components/CompanyFonts/CompanyFonts';
import AllFonts from './components/AllFonts/AllFonts';

const FontsList = ({ companyId }) => {
  return (
    <div className={styles.wrapper}>
      <CompanyFonts companyId={companyId} />
      <AllFonts />
    </div>
  );
};

export default FontsList;
